import * as React from 'react';
import { observer } from 'mobx-react';
import { DiagnosticsLogger } from '../store/schema/DiagnosticsLogState';
import { customRenderPanelMap } from '../actions/registerDiagnostics';

export interface CustomDiagnosticsPanelProps {
    logger: DiagnosticsLogger<any>;
}

@observer
export default class CustomDiagnosticsPanel extends React.Component<CustomDiagnosticsPanelProps> {
    render() {
        return customRenderPanelMap[this.props.logger.name]();
    }
}
